import styled from 'styled-components';

export const Styled = styled.div`
    .mini-alert {
        border-radius: 6px;
        padding: 6px 12px;
        padding-right: 24px;
        background-color: #f0f4f9;
        color: #363b3e;
        width: fit-content;
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: flex-start;
        gap: 6px;

        &.wrap {
            .text {
                white-space: normal;
            }
        }
        &.no-wrap {
            .text {
                white-space: nowrap;
            }
        }
        .text-area {
            padding: 0 5px;
        }
        .text {
            font-weight: 600;
        }
        .text-desc {
            color: var(--mui-palette-text-primary);
            font-weight: 600;
            max-width: 645px;
            font-size: 12px;
        }
        &.size-large {
            font-size: 14px;
            padding: 8px 16px;
            padding-right: 32px;
        }
        &.size-middle {
            font-size: 12px;
        }
        &.size-small {
            font-size: 10px;
            padding: 3px 8px;
            padding-right: 16px;
        }
        &.fullWidth-true {
            width: 100%;
        }

        .icon {
            transform: scale(1.3);
            line-height: 0;
            color: #c1c3c8;
            svg {
                font-size: inherit;
            }
        }

        &.state-success {
            background-color: #edf7ed;
            color: #1b5e20;
            .icon {
                color: #4caf50;
            }
        }
        &.state-error {
            background-color: #fdeded;
            color: #c62828;
            .icon {
                color: #d32f2f;
            }
        }
        &.state-error-outline {
            background-color: #fdeded;
            color: #c62828;
            .icon {
                color: #d32f2f;
            }
        }
        &.state-warning {
            background-color: #fff4e5;
            color: #e65100;
            .icon {
                color: #ed6c02;
            }
        }
        &.state-info {
            background-color: #e5f6fd;
            color: #01579b;

            .icon {
                color: #0288d1;
            }
        }
        &.info-mini {
            color: #646a76;
            background-color: #f0f4f9;
            padding: 10px 20px;
        }
    }
`;
